import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const chatThreadFileSchema = z.object({
  id: z.string(),
  fileName: z.string().optional(),
  fileUrl: z.string().url().optional(),
  uploadedAt: z.string().optional(),
  fileSize: z.number().optional(),
  hasPassword: z.boolean().optional(),
});
export type ChatThreadFile = z.infer<typeof chatThreadFileSchema>;

const userFileMetadataSchema = z.object({
  fileId: z.string(),
  hasPassword: z.boolean().optional(),
});

const updateChatThreadMetadataRequestSchema = z.object({
  userFiles: z.array(userFileMetadataSchema).optional(),
});

export type UpdateChatThreadMetadataRequest = z.infer<
  typeof updateChatThreadMetadataRequestSchema
>;

export const chatContract = c.router(
  {
    getChatThreadFiles: {
      method: 'GET',
      path: '/:tenantId/threads/:threadId/files',
      pathParams: z.object({
        tenantId: z.string(),
        threadId: z.string(),
      }),
      responses: {
        200: z.object({
          files: z.array(chatThreadFileSchema),
        }),
      },
    },
    updateChatThreadMetadata: {
      method: 'POST',
      path: '/:tenantId/threads/:threadId/metadata',
      pathParams: z.object({
        tenantId: z.string(),
        threadId: z.string(),
      }),
      query: z.object({
        patientId: z.string().optional(),
      }),
      body: updateChatThreadMetadataRequestSchema,
      responses: {
        200: z.object({
          threadMetadata: z.any(),
        }),
      },
    },
    decryptPdfFile: {
      method: 'POST',
      path: '/:tenantId/threads/:threadId/files/:fileId/decrypt',
      pathParams: z.object({
        tenantId: z.string(),
        threadId: z.string(),
        fileId: z.string(),
      }),
      body: z.object({
        password: z.string(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
          message: z.string(),
        }),
        400: z.object({
          error: z.string(),
        }),
      },
    },
    addFileToThread: {
      method: 'POST',
      path: '/:tenantId/threads/:threadId/files/:fileId/add',
      pathParams: z.object({
        tenantId: z.string(),
        threadId: z.string(),
        fileId: z.string(),
      }),
      body: z.object({}), // Empty body
      responses: {
        200: z.object({
          success: z.boolean(),
          fileMetadata: userFileMetadataSchema,
        }),
        400: z.object({
          error: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/chat' },
);
